import { render, staticRenderFns } from "./PageInvitesAndContacts.vue?vue&type=template&id=46d68196&"
import script from "./PageInvitesAndContacts.vue?vue&type=script&lang=js&"
export * from "./PageInvitesAndContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports